<template>
  <router-view></router-view>
</template>
<script setup>
  import { watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { setTicket } from '@/utils/auth.js';
  const route = useRoute();
  watch(
    () => route.query,
    (newQuery) => {
      const { app_id, ticket } = newQuery;
      if (ticket) {
        console.log("检测到 Ticket:", ticket);
        setTicket(ticket);
      }
    },
    { immediate: true, deep: true }
  );
</script>